const TYPE = {
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success'
}

export const customModalMixin = {
  created () {
    this.hideModalMixin()
  },

  data () {
    return {
      modalMixin: {},
      type: TYPE
    }
  },

  methods: {
    /**
     * Displays the custom modal with the given props.
     * @param {Object} modalData
     * @return {Object}
     */
    showModalMixin (modalData = {}) {
      if (!modalData) {
        return
      }

      const {
        closable = true,
        maskClosable = false
      } = modalData

      this.modalMixin = { ...modalData, closable, maskClosable, visible: true }
    },

    /**
     * Hides the custom modal.
     * @return {Object}
     */
    hideModalMixin () {
      this.modalMixin = {
        visible: false,
        category: '',
        title: '',
        icon: '',
        message: '',
        formName: '',
        actionButtons: [],
        cancelButton: {},
        autoClose: 0
      }
    }
  }
}
